import { render, staticRenderFns } from "./ImagesIcon.vue?vue&type=template&id=60db0d16&scoped=true&"
import script from "./ImagesIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImagesIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db0d16",
  null
  
)

export default component.exports